import { render, staticRenderFns } from "./AliPayWithdrawal.vue?vue&type=template&id=89370c64&scoped=true&"
import script from "./AliPayWithdrawal.vue?vue&type=script&lang=js&"
export * from "./AliPayWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./AliPayWithdrawal.vue?vue&type=style&index=0&id=89370c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89370c64",
  null
  
)

export default component.exports